import type { Router } from 'vue-router'
import { defineNuxtPlugin, useCookie } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30
  const COOKIE_OPTIONS = {
    maxAge: COOKIE_MAX_AGE_SECONDS,
    sameSite: 'lax' as const,
    path: '/',
    secure: typeof window !== 'undefined' ? window.location.protocol === 'https:' : true,
  }

  const allowedKeys = ['utm_source', 'web_id', 'click_id'] as const
  type AllowedKey = typeof allowedKeys[number]

  const setCookieIfPresent = (key: AllowedKey, value?: string | null) => {
    if (!value)
      return
    const cookieRef = useCookie<string | null>(key, COOKIE_OPTIONS)
    cookieRef.value = value
  }

  const processFromSearch = (search: string) => {
    const params = new URLSearchParams(search)
    allowedKeys.forEach((key) => {
      const value = params.get(key)
      if (value)
        setCookieIfPresent(key, value)
    })
  }

  const processFromQueryObject = (query: Record<string, unknown>) => {
    allowedKeys.forEach((key) => {
      const raw = query[key]
      if (typeof raw === 'string')
        setCookieIfPresent(key, raw)
      else if (Array.isArray(raw) && raw.length > 0 && typeof raw[0] === 'string')
        setCookieIfPresent(key, raw[0] as string)
    })
  }

  if (import.meta.client) {
    if (typeof window !== 'undefined')
      processFromSearch(window.location.search)

    const router = nuxtApp.$router as Router | undefined
    if (router) {
      router.afterEach((to) => {
        if (to && to.query)
          processFromQueryObject(to.query as Record<string, unknown>)
      })
    }
  }
})
